module.exports = __webpack_public_path__ + "static/media/ticket.75789b3d.svg";